import {localCommand} from "../utils/api";

export const START_LESSON = 'START_LESSON';
export const START_LESSON_SUCCESS = 'START_LESSON_SUCCESS';
export const START_LESSON_FAILED = 'START_LESSON_FAILED';
export const startLesson = localCommand('v1/lesson/StartLesson', START_LESSON, START_LESSON_SUCCESS, START_LESSON_FAILED);
